import axios from "axios";
import { getAuthHeaders } from "../../Api";
import { isBagelAdmin } from "../../utils";

const API_BASE_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/global_collections/users";

export const updateUserAccountId = async (
  userId: string,
  newAccountId: string,
  auth0: any
) => {
  try {
    const isBagelUser = isBagelAdmin(auth0?.user);
    if (!isBagelUser) {
      throw new Error("You are not authorized to access this resource");
    }
    
    const config = await getAuthHeaders(auth0);
    const response = await axios.post(
      `${API_BASE_URL}/update-account-id`,
      { userId, newAccountId },
      config
    );
    return response.data.result;
  } catch (e) {
    console.error("Error updating user accountId", e);
    throw e;
  }
}; 